/**
 * SkipToContent — WCAG 2.1 AA / BITV 2.0 (2.4.1 Bypass Blocks).
 *
 * Unsichtbar bis Tab — beim ersten Tab-Druck springt der Fokus auf diesen
 * Link und wird sichtbar. Der Klick (Enter) springt zum Hauptinhalt
 * (`#main-content` muss als Fokus-Ziel im Layout existieren).
 *
 * Behördlich relevant für Screen-Reader- und Tastatur-User: erspart das
 * Durchtabben durch Header / Navigation auf jeder Seite.
 *
 * Bewusst KEINE eigenen Animationen — `prefers-reduced-motion` ist global
 * via index.css respektiert; ein simples Visible-on-Focus reicht.
 */

import type { ReactNode } from 'react';

interface SkipToContentProps {
  /** ID des Hauptinhalt-Elements. Default `main-content`. */
  readonly targetId?: string;
  readonly children?: ReactNode;
}

export function SkipToContent({ targetId = 'main-content', children }: SkipToContentProps) {
  return (
    <a
      href={`#${targetId}`}
      // sr-only bis Focus, dann sichtbar mit eigenen Position-Fix-Klassen.
      // focus:not-sr-only kommt mit Tailwind ootb.
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:inline-flex focus:items-center focus:rounded-sm focus:bg-stone-900 focus:px-4 focus:py-3 focus:font-sans focus:text-xs focus:font-medium focus:uppercase focus:tracking-widest focus:text-white focus:outline-none focus:ring-2 focus:ring-amber-300 focus:ring-offset-2"
    >
      {children ?? 'Direkt zum Inhalt springen'}
    </a>
  );
}
